// Entry point. Owned by the data-layer/app-shell agent (phase 3B).
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles/index.css';

// Dev-only handle for debugging and browser automation (stripped from production builds).
if (import.meta.env.DEV) {
  void Promise.all([import('./state/store'), import('./net/socket')]).then(([store, net]) => {
    (globalThis as Record<string, unknown>).__20fight = {
      useStore: store.useStore,
      getSocket: net.getSocket,
    };
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
